/*
 * vendor/registrations/show.js — esbuild IIFE entry
 * Migrated from app/assets/javascripts/vendor/registrations/show.js
 * Uses PdfViewer global (provided by protenders_legacy.js).
 */

window.ShowRegistrations = {
    _workerUrl: null,

    initialize(workerUrl) {
        this._workerUrl = workerUrl;
        const $selectedRowLink = $('.tabs.document-rows').find('a.view-document.active');
        const firstDocumentUrl = $selectedRowLink.data('documentUrl');
        const firstName = $selectedRowLink.data('documentName');

        this._setFirstDocument(firstDocumentUrl, firstName);
        $(document).on('click', 'a.view-document', _.bind(this._handleViewDocumentLinkClick, this));
        $(document).on('firstPageRendered', this._enableDocumentsLinks);
        PdfViewer.setupDocumentTools();
    },

    _setFirstDocument(firstDocumentUrl, documentName) {
        PdfViewer.setDocument(firstDocumentUrl, this._workerUrl);
        this._setDocumentName(documentName);
    },

    _handleViewDocumentLinkClick(event) {
        event.preventDefault();
        const $link = $(event.currentTarget);
        const documentUrl = $link.data('documentUrl');
        const downloadUrl = $link.data('downloadUrl');

        this._setSelectedClass($link);
        this._disableDocumentsLinks();
        this._setDocument(documentUrl);
        this._setDownloadUrl(downloadUrl);
        this._setDocumentName($link.text());
    },

    _setDocument(documentUrl) {
        PdfViewer.startLoading();
        PdfViewer.setDocument(documentUrl, this._workerUrl);
    },

    _setDocumentName(documentName) { $('#doc-name').text(documentName); },
    _setDownloadUrl(downloadUrl) { $('#download-document').prop('href', downloadUrl); },
    _disableDocumentsLinks() { $('.view-document').toggleClass('disabled', true); },
    _enableDocumentsLinks() { $('.view-document').toggleClass('disabled', false); },

    _setSelectedClass($documentLink) {
        $('.document-row').toggleClass('active', false);
        $documentLink.closest('.document-row').toggleClass('active', true);
    }
};
